import React from 'react';
import { bool, string } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';

const PublishButton = ({ disabled = false, type }) => (
  <Button
    disabled={disabled}
    color="primary"
    type={type}
    variant="contained"
    sx={theme => ({
      minWidth: '90px',
      fontSize: '15px',
      color: theme.palette.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
      borderColor: theme.palette.primary.main,
    })}
  >
    {I18n.t('AcknowledgementCreate.Publish')}
  </Button>
);
PublishButton.propTypes = {
  type: string.isRequired,
  disabled: bool,
};

export default PublishButton;
